import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg4Styles = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "4 Styles" }), /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "24x24px---NoNo-Def-No-Frame-&-Header-Color",
			transform: "translate(-267.000000, -223.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Landscape",
				transform: "translate(53.000000, 223.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "4-Styles",
					transform: "translate(214.000000, 0.000000)",
					children: [/* @__PURE__ */ _jsx("rect", {
						id: "Frame-for-Icon",
						x: 0,
						y: 0,
						width: 24,
						height: 24
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Icon",
						transform: "translate(1.000000, 3.000000)",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: 1,
								transform: "translate(18.000000, 0.000000)",
								children: [/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#AFBCC5",
									x: 0,
									y: 17,
									width: 3,
									height: 1,
									rx: .15
								}), /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#8C9BA8",
									x: 0,
									y: 0,
									width: 4,
									height: 16,
									rx: .15
								})]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: 1,
								transform: "translate(12.000000, 0.000000)",
								children: [/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#AFBCC5",
									x: 0,
									y: 17,
									width: 3,
									height: 1,
									rx: .15
								}), /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#8C9BA8",
									x: 0,
									y: 0,
									width: 4,
									height: 16,
									rx: .15
								})]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: 1,
								transform: "translate(6.000000, 0.000000)",
								children: [/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#AFBCC5",
									x: 0,
									y: 17,
									width: 3,
									height: 1,
									rx: .15
								}), /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#8C9BA8",
									x: 0,
									y: 0,
									width: 4,
									height: 16,
									rx: .15
								})]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: 1,
								children: [/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#AFBCC5",
									x: 0,
									y: 17,
									width: 3,
									height: 1,
									rx: .15
								}), /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									fill: "#8C9BA8",
									x: 0,
									y: 0,
									width: 4,
									height: 16,
									rx: .15
								})]
							})
						]
					})]
				})
			})
		})
	})]
});
export { Svg4Styles as ReactComponent };
